<template>
    <div>
   
    </div>

</template>

<script>

export default {

  data(){
    return{
     
    }
  },
  mounted () {
     this.$router.push({
          name: localStorage.getItem('homeName')||this.$config.homeName
        })
  },
  methods: {
     
  }
}
</script>

<style >

</style>
